import { render, staticRenderFns } from "./text.editor.vue?vue&type=template&id=4d72849d&scoped=true&"
import script from "./text.editor.vue?vue&type=script&lang=ts&"
export * from "./text.editor.vue?vue&type=script&lang=ts&"
import style0 from "./text.editor.vue?vue&type=style&index=0&id=4d72849d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72849d",
  null
  
)

export default component.exports